module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [_c('ol', {
    staticClass: "breadcrumb"
  }, [_c('li', [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('i', {
    staticClass: "ti-home"
  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    attrs: {
      "to": {
        name: 'devices'
      }
    }
  }, [_vm._v("Devices")])], 1), _vm._v(" "), _c('li', {
    staticClass: "active"
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Edit Device")])])])]), _vm._v(" "), _c('section', {
    staticClass: "content device-content"
  }, [_c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.loading),
      expression: "loading"
    }],
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('el-form', {
    ref: "device",
    attrs: {
      "model": _vm.device,
      "rules": _vm.rules,
      "label-width": "120px",
      "label-position": "top"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Name",
      "prop": "name"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.device.name),
      callback: function($$v) {
        _vm.$set(_vm.device, "name", $$v)
      },
      expression: "device.name"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "Serial",
      "prop": "serial"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.device.serial),
      callback: function($$v) {
        _vm.$set(_vm.device, "serial", $$v)
      },
      expression: "device.serial"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "md": 24,
      "lg": 8
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "ICC Id",
      "prop": "iccId"
    }
  }, [_c('el-input', {
    model: {
      value: (_vm.device.iccId),
      callback: function($$v) {
        _vm.$set(_vm.device, "iccId", $$v)
      },
      expression: "device.iccId"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "channels",
      "prop": "channels"
    }
  }, [_c('template', {
    slot: "label"
  }, [_vm._v("\n                channels\n                "), _c('el-button', {
    attrs: {
      "type": "success",
      "icon": "el-icon-plus",
      "size": "mini"
    },
    on: {
      "click": _vm.addChannel
    }
  }, [_vm._v("Add")])], 1), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.device.channels
    }
  }, [_c('template', {
    slot: "empty"
  }, [_vm._v("Loading...")]), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Name",
      "prop": "name"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          attrs: {
            "inline-message": true,
            "prop": ("channels." + (scope.$index) + ".name"),
            "rules": {
              required: true,
              message: 'Please input device channel name',
              trigger: 'blur'
            }
          }
        }, [_c('el-input', {
          model: {
            value: (_vm.device.channels[scope.$index].name),
            callback: function($$v) {
              _vm.$set(_vm.device.channels[scope.$index], "name", $$v)
            },
            expression: "device.channels[scope.$index].name"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "Channel",
      "prop": "channelIndex"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-form-item', {
          attrs: {
            "prop": ("channels." + (scope.$index) + ".channelIndex"),
            "rules": {
              type: 'number',
              required: true,
              message: 'Please input device channel index',
              trigger: 'blur'
            }
          }
        }, [_c('el-input-number', {
          attrs: {
            "min": 0,
            "max": 10
          },
          model: {
            value: (_vm.device.channels[scope.$index].channelIndex),
            callback: function($$v) {
              _vm.$set(_vm.device.channels[scope.$index], "channelIndex", $$v)
            },
            expression: "device.channels[scope.$index].channelIndex"
          }
        })], 1)]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "right"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "mini",
            "type": "danger",
            "icon": "el-icon-minus",
            "disabled": _vm.device.channels.length <= 1
          },
          on: {
            "click": function($event) {
              return _vm.handleRemove(scope.$index)
            }
          }
        }, [_vm._v("Remove")])]
      }
    }])
  })], 2)], 2), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('device')
      }
    }
  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('device')
      }
    }
  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('hr')], 1)])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e7299674!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modules/devices/Edit.vue
// module id = 1169
// module chunks = 2